module.exports = __webpack_public_path__ + "img/banner-1_AR-mobile.862c3c98.png";